import { ComponentType, lazy } from "react";

const RELOADED_AT_KEY = "chunkReloadedAt";
const RELOAD_GUARD_MS = 30_000;

/**
 * React.lazy for a named export. A deploy replaces every chunk, so a tab opened before it
 * can fail to fetch one: reload once to pick up the new build instead of rendering nothing.
 */
export function lazyNamed<M extends Record<K, ComponentType<any>>, K extends keyof M>(load: () => Promise<M>, name: K) {
    return lazy<M[K]>(() => load()
        .then(module => ({ default: module[name] }))
        .catch(error => {
            if (reloadedRecently()) {
                throw error;
            }
            markReloaded();
            window.location.reload();
            return new Promise<never>(() => {});
        }));
}

function reloadedRecently() {
    try {
        return Date.now() - Number(sessionStorage.getItem(RELOADED_AT_KEY) || 0) < RELOAD_GUARD_MS;
    } catch {
        return true;
    }
}

function markReloaded() {
    try {
        sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    } catch {
        // no storage: the guard above then refuses to reload at all
    }
}
